import { useTenantNavigate } from '@app-store'
import { PropsWithChildren, useEffect } from 'react'
import { RootState, useAppSelector } from '../utils/agent.store'
import { canAccessGlobalPermissionSetConfiguration } from '../utils/helperFunctions'

const NavigateToPage: React.FC<{ url: string }> = ({ url }) => {
  const navigate = useTenantNavigate()
  useEffect(() => {
    navigate(url)
  }, [url])
  return <></>
}

export const AdminProtectedRoute: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const canAccessGlobal = useAppSelector(
    (state: RootState) =>
      state.authUser.user?.superAdmin ||
      canAccessGlobalPermissionSetConfiguration(state)
  )

  if (!canAccessGlobal) {
    return <NavigateToPage url="/" />
  } else {
    return children
  }
}
